import React from "react";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProgressBar from "../../components/progress-bar/ProgressBar.component";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import useWindowSize from "../../hooks/useWindowSize";
import CustomButtonLoader from "../../components/global/CustomButtonLoader.component";

const CustomSideModal = ({
  t,
  isOpen,
  title,
  buttonArrayData,
  closeModal,
  children,
  subTitle,
  subFooterComponent,
  buttonClass,
}) => {
  const windowSize = useWindowSize();
  const modalHeadRef = React.useRef(null);
  const modalSubHeadRef = React.useRef(null);
  const modalFootRef = React.useRef(null);

  const [contentHeight, setContentHeight] = React.useState(null);
  React.useEffect(() => {
    setTimeout(() => {
      if (!!modalHeadRef.current) {
        setContentHeight(
          window.innerHeight -
            (modalHeadRef.current.clientHeight +
              (!!modalSubHeadRef?.current?.clientHeight
                ? modalSubHeadRef.current.clientHeight
                : 0) +
              (!!modalFootRef?.current?.clientHeight
                ? modalFootRef.current.clientHeight
                : 0)) -
            3
        );
      }
    }, 100);
  }, [children]);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    !open && closeModal();
  };

  const list = (anchor) => (
    <Box
      sx={{ width: windowSize.screenWidth <= 991 ? "100%" : 800 }}
      role="presentation"
    >
      <div
        className="cm-taskdetail-modal-header d-flex justify-content-between align-items-center border-bottom border-blue-gray-100"
        ref={modalHeadRef}
      >
        <p className="my-0 fw-medium text-blue-800 cm-truncate-1 pe-2">
          {t(title)}
        </p>
        <FontAwesomeIcon
          icon={regular("times")}
          className="text-blue-800 cm-pointer"
          onClick={toggleDrawer(false)}
        />
      </div>
      {!!subTitle && (
        <div
          className="cm-taskdetail-modal-sh cm-sm-txt text-primary bg-blue-gray-50"
          ref={modalSubHeadRef}
        >
          <p className="my-0 cm-xs-txt fw-medium text-blue-gray-700">
            {t(subTitle)}
          </p>
        </div>
      )}
      <div
        className="cm-set-centre-empty"
        style={{
          height: !!contentHeight ? `${contentHeight}px` : "auto",
          overflow: "auto",
        }}
      >
        {children}
      </div>
      {buttonArrayData?.length > 0 && (
        <div ref={modalFootRef}>
          {!!subFooterComponent && subFooterComponent}
          <div className={`cm-taskdetail-modal-footer d-flex ${buttonClass}`}>
            {buttonArrayData.map((el, ind) => {
              return (
                <CustomButtonLoader
                  showLoadingState={
                    el.hasOwnProperty("buttonLoading") ? el.buttonLoading : null
                  }
                  key={ind}
                  disabled={el?.disabled}
                  icon={el.icon}
                  buttonLabel={t(el.btnName)}
                  colorTheme={el.colorTheme}
                  buttonStyle={el.cssSty}
                  handleOnClick={el.handleBtnClick}
                />
              );
            })}
          </div>
        </div>
      )}
    </Box>
  );
  return (
    <Drawer
      anchor={"right"}
      open={isOpen}
      onClose={toggleDrawer()}
      className="cm-tasklist-modal-wrapper"
      id="add-tasks-modal"
    >
      {!!isOpen ? (
        list("right")
      ) : (
        <div className="py-4 d-flex align-items-center justify-content-center">
          <ProgressBar />
        </div>
      )}
    </Drawer>
  );
};

export default CustomSideModal;
